<template>
  <b-form @submit.prevent="onSubmit()" class="w-100">
      <b-col sm="12"  class="py-3 bg-light border mb-3 rounded">
        <b-row>
          <b-col md="7">
            <b-row>
              <b-col md="6">
                <label class="font-weight-bold my-0" v-translate>Booking between</label>
                <DatePicker
                  v-model="bookingFrom"
                  key="bookingFrom"
                  lang="en"
                  :today-label="$gettext('today')"
                  :selected-date-label="$gettext('selected date')"
                  size="sm" />
              </b-col>
              <b-col md="6">
                <label class="font-weight-bold my-0" v-translate>and</label>
                <DatePicker
                  v-model="bookingTo"
                  key="bookingTo"
                  lang="en"
                  :today-label="$gettext('today')"
                  :selected-date-label="$gettext('selected date')"
                  size="sm" />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <label class="font-weight-bold my-0" v-translate>Departure between</label>
                <DatePicker
                  v-model="travelFrom"
                  key="travelFrom"
                  lang="en"
                  :today-label="$gettext('today')"
                  :selected-date-label="$gettext('selected date')"
                  size="sm" />
              </b-col>
              <b-col md="6">
                <label class="font-weight-bold my-0" v-translate>and</label>
                <DatePicker
                  v-model="travelTo"
                  key="travelTo"
                  lang="en"
                  :today-label="$gettext('today')"
                  :selected-date-label="$gettext('selected date')"
                  size="sm" />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$gettext('Booking number')"
                  label-class="font-weight-bold my-0"
                  label-for="booking-number"
                  >
                  <b-input
                    type="text"
                    name="rezervare"
                    id="booking-number"
                    v-model="params.bookingId"
                    size="sm" />
                  </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$gettext('Passenger name')"
                  label-class="font-weight-bold my-0"
                  label-for="name"
                  >
                  <b-input
                    type="text"
                    name="pasager"
                    v-model="params.name"
                    id="name"
                    size="sm" />
                  </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$gettext('Keyword')"
                  label-class="font-weight-bold my-0"
                  label-for="key-word"
                  >
                  <b-input
                    type="text"
                    name="keyWord"
                    v-model="params.keyword"
                    id="key-word"
                    size="sm" />
                  </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="pt-4 offset-md-1">
            <BookingSummary :results="results"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" class="d-flex align-items-center justify-content-end">
            <b-button variant="primary" size="sm" type="submit"><b-icon icon="search" /><span class="ml-2" v-translate>Search</span></b-button>
          </b-col>
        </b-row>
      </b-col>
  </b-form>
</template>

<script>

import BookingSummary from './booking_summary'
import moment from 'moment'

import DatePicker from 'b2b-common/components/datepicker'

export default {
  props: ['params', 'results'],
  components: { DatePicker, BookingSummary },
  computed: {
    bookingFrom: {
      get () {
        return this.params.bookingFrom ? moment(this.params.bookingFrom, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.bookingFrom = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    bookingTo: {
      get () {
        return this.params.bookingTo ? moment(this.params.bookingTo, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.bookingTo = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    travelFrom: {
      get () {
        return this.params.travelFrom ? moment(this.params.travelFrom, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.travelFrom = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    travelTo: {
      get () {
        return this.params.travelTo ? moment(this.params.travelTo, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.travelTo = val ? moment(val).format('DD-MM-YYYY') : null
      }
    }
  },
  methods: {
    onSubmit () {
      this.$emit('search', this.params)
    }
  }
}
</script>
